import React, { useContext, useEffect, useState } from 'react';
import { ColumnProps, FormInput, Row, Table } from '@digital/ui';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { Typography } from 'antd';
import { obterDadosAprovacaoTotvs } from '@app/api/demanda';
import { Visibility } from '@app/components';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { EStepQuestionarioDemandaReavaliacaoRC, EStepQuestionarioDemandaRequisicao, EStepQuestionarioDemandaRequisicaoModificacao } from '@app/enums/EStepQuestionarioDemanda';

const { Title } = Typography;

const RequisicaoCompraOcDdi = () => {
  const { demandaData } = useContext(QuestionarioContextProvider);
  const [dataAprovacao, setdataAprovacao] = useState<any[]>([]);

  useEffect(() => {
    if (demandaData) {
      obterDadosAprovacaoTotvs(demandaData.id).then(data => setdataAprovacao(data));
    }
  }, [demandaData]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Tipo',
      dataIndex: 'tipo',
    },
    {
      title: 'Aprovador',
      dataIndex: 'aprovador',
    },
    {
      title: 'Aprovador Alternativo',
      dataIndex: 'aprovadorAlternativo',
    },
    {
      title: 'Data Geração',
      dataIndex: 'dataGeracaoString',
    },
    {
      title: 'Data Aprovação',
      dataIndex: 'dataAprovacaoString',
    },
    {
      title: 'Situação',
      dataIndex: 'situacao',
    },
    {
      title: 'Rejeição',
      dataIndex: 'rejeicao',
    },
  ];

  return (
    <>
      <Visibility
        visible={demandaData && 
          [
            EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC, 
            EStepQuestionarioDemandaRequisicaoModificacao.AguardandoAprovacaoRC,
            EStepQuestionarioDemandaReavaliacaoRC.AguardandoAprovacaoRC,
          ].includes(demandaData.step)}
      >
        <Row>
          <FormInput
            label="Número RC Totvs"
            name="reqCompra"
            id='mrn-input-reqCompra'
            span={4} disabled />
          <FormInput
            label="Situação RC Totvs"
            name="statusRC"
            id='mrn-input-statusRC'
            span={4} disabled />
          <FormInput
            label="Número OC Totvs"
            name="ordemCompra"
            id='mrn-input-ordemCompra'
            span={4} disabled />
        </Row>

        <Row>
          <Title
            id='mrn-label-RequisicaoCompraOcDdi-AguardandoAprovacaoRC'
            level={4}> Informações de Aprovação da Requisição e Compra no Totvs </Title>
          <Table
            id="mrn-table-RequisicaoCompraOcDdi"
            style={{ paddingInline: '4px' }} columns={columns} dataSource={dataAprovacao} pagination={false} />
        </Row>
      </Visibility>

      <Visibility
        visible={demandaData &&
          [
            EStepQuestionarioDemandaRequisicao.AguardandoSuprimentos, 
            EStepQuestionarioDemandaRequisicaoModificacao.AguardandoSuprimentos, 
            EStepQuestionarioDemandaReavaliacaoRC.AguardandoSuprimentos, 
          ].includes(demandaData.step)}
      >
        <div style={{ textAlign: 'center' }}>
          <h3
            id='mrn-label-RequisicaoCompraOcDdi-AguardandoSuprimentos'
            style={{ color: 'rgb(105,105,105' }}>
            Sua demanda foi direcionada para Suprimentos.
          </h3>
        </div>
      </Visibility>
    </>
  );
};

export default RequisicaoCompraOcDdi;
